<template>
  <div :class="[ 'w-full pt-4 border-t border-primary-neutral', isOpen ? 'mb-4' : 'mb-2' ]">
    <button
      :class="[ 'flex items-center w-full text-start outline-none focus:outline-none focus:ring-0 hover:no-underline text-base font-bold pb-2', isDetail ? 'text-bolder' : 'text-heading' ]"
    >
      <div class="flex justify-between items-center w-full cursor-pointer" @click="toggleCollapse">
        <label :htmlFor="`parameter_${parameter.idParameter}`">
          {{ parameter.name }}
        </label>
        <div :class="['ms-auto', isDetail ? 'text-bolder' : 'text-heading']">
          <MinusIcon v-if="isOpen" class="w-6 h-6" />
          <PlusIcon v-else class="w-6 h-6" />
        </div>
      </div>
    </button>
    <template v-if="isOpen">
      <div v-for="item in parameter.values" :key="item.id">
        <FilterParameterValue :parameter="parameter" :item="item" :is-detail="isDetail" @changed="(value) => handleChanged(item, value)" />
      </div>
    </template>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import PlusIcon from "@components/icons/plus-icon";
import MinusIcon from "@components/icons/minus-icon";
import FilterParameterValue from "@components/filter/filter-parameter-value";

const props = defineProps({
  parameter: {
    type: Object,
    required: true
  },
  queryCode:  {
    type: String,
    default: 'p'
  },
  isDetail: {
    type: Boolean,
    default: false
  }
});

const route = useRoute();
const queryKey = `${props.queryCode}[${props.parameter.idParameter}]`;

const isOpen = ref(_.includes(_.keys(route.query), `${props.queryCode}[${props.parameter.idParameter}]`));

const toggleCollapse = () => {
  isOpen.value = !isOpen.value;
}

const handleChanged = async (parameterValue, value) => {
  const checked = _.chain(props.parameter.values)
    .filter((item) => parameterValue.id === item.id ? value : item.value)
    .map((item) => item.id)
    .join(',')
    .value();
  await useSearchParam(queryKey, checked);
}
</script>
